import dayjs from "dayjs"
import dayjsDuration from "dayjs/plugin/duration"
dayjs.extend(dayjsDuration)

export const SECONDS_IN_HOUR = 3600
export const SKIP_BACK_SECONDS = 15
export const SKIP_FORWARD_SECONDS = 30

export function parseDuration(duration: number) {
  const hours = Math.floor(duration / SECONDS_IN_HOUR)
  const minutes = Math.floor((duration % SECONDS_IN_HOUR) / 60)
  const seconds = Math.floor(duration % 60)

  return { hours, minutes, seconds }
}

export function formatDuration(duration: number) {
  const time = parseDuration(duration)
  const formatString =
    time.hours > 0 ? "H:mm:ss" : time.minutes > 9 ? "mm:ss" : "m:ss"

  return duration ? dayjs.duration(time).format(formatString) : ""
}

export function formatDatetimeDuration(duration: number) {
  const time = parseDuration(duration)

  return duration ? dayjs.duration(time).format("[PT]H[H]m[M]s[S]") : "PT0H0M0S"
}
